var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { call, put, takeLatest } from "redux-saga/effects";
import { FETCH_FILE_STATUS_REQUEST, fetchFileStatusSuccess, fetchFileStatusFailure } from "../../actions";
import APIIN from "@/utils/APIIN";
const fetchFileStatus = (action) => __awaiter(void 0, void 0, void 0, function* () {
    return yield new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const fileId = action.payload.fileId;
            APIIN.get(`order/bulk/status/file/${fileId}`, action.payload)
                .then((data) => {
                resolve(data);
            })
                .catch((error) => {
                reject(error);
            });
        }
        catch (error) {
            if (error instanceof Error) {
                reject(error);
            }
        }
    }));
});
function* fetchFileStatusWorker(action) {
    try {
        const data = yield call(fetchFileStatus, action);
        yield put(fetchFileStatusSuccess(data));
    }
    catch (error) {
        yield put(fetchFileStatusFailure(error));
    }
}
export function* watchFetchFileStatus() {
    yield takeLatest(FETCH_FILE_STATUS_REQUEST, fetchFileStatusWorker);
}
